import React, { useState, useEffect } from "react";
import { campaignColumns, campaignRows } from "../../../constants/bussiness";
import BasicCustomTable from "../../../component/basicTable";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";
import { useSelector } from "react-redux";
import { dateFormatShort, formatDateDDMMYYYY } from "../../../utils/dateFormat";
import { formatServiceType } from "../../../utils/customerHealperFunctions";
import { customerValueToLabel } from "../../../constants/campaignConstants";

export default function Campaign() {
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();
  const [campaignData, setCampaignData] = useState([]);
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const handleAddCampaign = () => {
    navigate(`/app/promotions&marketing/create`);
  };

  useEffect(() => {
    fetchCampign();
  }, []);

  const fetchCampign = (pageNumber = 1, limit = 10) => {
    axiosInstance
      .get(
        `/customer/store/campaign?storeId=${storeId}&page=${pageNumber}&limit=${limit}`
      )
      .then((res) => {
        const formattedUser = res?.data?.campaigns?.map((item) => ({
          id: item?.id,
          name: item?.name,
          code: item?.code,
          start_date: formatDateDDMMYYYY(item?.startDate),
          end_date: formatDateDDMMYYYY(item?.endDate),
          order_status: item?.isActive ? "Active" : "Inactive",
          promotionType: item?.promotionType,
          // Type: item?.isPrivate ? "Private"   : "Public",
          service_type: formatServiceType(item?.service_type),
          minimum_order_count: item?.minimum_order_count,
          customerTag:
            item?.customerTag?.length > 0
              ? item.customerTag
                  .map((cat) => customerValueToLabel(cat))
                  .join(", ")
              : "",
        }));
        setPage(res?.data?.currentPage || 1);
        setTotalCount(res?.data?.total || 0);
        setCampaignData(formattedUser);
      })
      .catch((err) => showSnackbar("Something went wrong!", "error"));
  };

  const handlePageChangeRequest = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
    fetchCampign(newPage, newRowsPerPage);
  };

  const handleStatusChange = (status, rowData) => {
    const payload = {
      isActive: status === "active" ? true : false,
    };
    

    axiosInstance
      .patch(`/customer/store/campaign/${rowData.id}`, payload)
      .then(() => {
        fetchCampign();
      })
      .catch(() => {
        showSnackbar("Something went wrong!", "error");
      });
  };

  return (
    <div className="px-4 pb-4 h-[calc(100vh-210px)]">
      <div className="flex justify-end mb-3">
        <CustomButton
          onClick={() => handleAddCampaign()}
          customeClass="gradient-button w-[140px] h-[45px] mr-1"
        >
          + Add New
        </CustomButton>
      </div>
      <BasicCustomTable
        columns={campaignColumns}
        rows={campaignData}
        colorHeader={true}
        customClassHeader={"table-header-cell-colored"}
        tableName="campaign"
        onTagChange={handleStatusChange}
        maxHeightClass="max-h-[calc(100vh-345px)]"
        backendPagination={true}
        totalCount={totalCount}
        onPageChangeRequest={handlePageChangeRequest}
        pageLimit={rowsPerPage}
        page={page}
      />
    </div>
  );
}
